'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./Stepper.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

// Generated with utils/create-component.js
var steps = function (stepDetails, index) { return (React__default['default'].createElement("li", { className: "stepper__item", key: index },
    React__default['default'].createElement("div", { className: "stepper" },
        React__default['default'].createElement("div", { className: "stepper__button" }, stepDetails.count),
        React__default['default'].createElement("span", null,
            React__default['default'].createElement("p", null, stepDetails.title),
            React__default['default'].createElement("p", null, stepDetails.subtitle))))); };
var Stepper = function (props) {
    var stepperDetails = props.stepperDetails;
    return (React__default['default'].createElement("ul", { className: "stepper__wrapper" }, stepperDetails.map(function (step, index) { return steps(step, index); })));
};

exports.Stepper = Stepper;
//# sourceMappingURL=Stepper.js.map
